import { siteConfig } from "@/config/site";

export interface PageMetadata {
  path: string;
  title: string;
  description: string;
  canonical: string;
  indexable: boolean;
}

const definitions = [
  {
    path: "/",
    title: siteConfig.title,
    description: siteConfig.description,
    indexable: true,
  },
  {
    path: "/services/vehicle-debts",
    title: "عوارض سالیانه خودرو (سمیع) برای دفاتر پلیس ۱۰+ | پلیس پلاس",
    description:
      "راهنمای خدمت عوارض سالیانه خودرو (سمیع) در پنل پلیس پلاس برای دفاتر پلیس ۱۰+؛ بررسی دسترسی دفتر، مراحل استعلام و پرداخت و پیگیری نتیجه درخواست.",
    indexable: true,
  },
  {
    path: "/guides/vehicle-service-panel",
    title: "چک‌لیست انتخاب پنل خدمات خودرو برای دفاتر | پلیس پلاس",
    description:
      "راهنمای انتخاب پنل خدمات خودرو برای دفاتر پلیس ۱۰+؛ پرسش‌های پوشش خدمات، دسترسی کاربران، پیگیری درخواست و شرایط مالی پیش از شروع همکاری.",
    indexable: true,
  },
  {
    path: "/dashboard",
    title: `داشبورد | ${siteConfig.name}`,
    description: "نمونه‌ی معماری داشبورد React با داده، حالت‌های کامل و Design System سازمانی.",
    indexable: false,
  },
  {
    path: "/style-guide",
    title: `راهنمای رابط | ${siteConfig.name}`,
    description: "نمایش وضعیت‌ها و اجزای پایه‌ی Design System در پروژه.",
    indexable: false,
  },
  {
    path: "/contact",
    title: `تماس | ${siteConfig.name}`,
    description:
      "ثبت پیام و درخواست راهنمایی دفاتر در پشتیبانی پلیس پلاس، همراه با راه تماس تلفنی.",
    indexable: true,
  },
  {
    path: "/privacy",
    title: `حریم خصوصی | ${siteConfig.name}`,
    description: "صفحه‌ی پایه برای جایگزینی با سیاست حریم خصوصی تاییدشده‌ی پروژه.",
    indexable: false,
  },
  {
    path: "/404",
    title: `صفحه پیدا نشد | ${siteConfig.name}`,
    description: "صفحه‌ی درخواستی پیدا نشد.",
    indexable: false,
  },
] as const;

function normalizePath(pathname: string): string {
  if (pathname === "/") return pathname;
  return pathname.replace(/\/$/, "");
}

export const prerenderRoutes = definitions.map((definition) => ({ path: definition.path }));

export function getPageMetadata(pathname: string): PageMetadata {
  const path = normalizePath(pathname);
  const definition = definitions.find((item) => item.path === path) ?? definitions.at(-1);
  if (!definition) throw new Error("Page metadata definitions are empty.");
  const canonicalPath = definition.path === "/404" ? path : definition.path;

  return {
    ...definition,
    path,
    canonical: new URL(canonicalPath, siteConfig.siteUrl).toString(),
  };
}
